import { observable, action } from 'mobx'
import { apis, request } from '@/utils/net'

class Store {
    @observable loading = false

    @observable isAdmin = false

    @observable.shallow userInfo = {}

    // 税率列表（排除已弃用的）
    @observable.shallow taxList = []

    // 所有的税率列表
    // 列表查询页面的查询下拉框需要显示所有的
    @observable.shallow allTaxList = []

    @observable.shallow updateNotice = []

    //获取税率列表
    @action getTaxList(){
        return request({url: apis.getTaxRate}).then(res => {
            const allTaxList = res || []
            this.allTaxList = allTaxList
            this.taxList = allTaxList.filter(item => item.is_deleted !== '1')
        })
    }

    @action getUserInfo() {
        return request({url: apis.getUserInfo}).then(res => {
            this.userInfo = res
            // 是否管理员，1 是 0 否
            this.isAdmin = res.isAdmin === 1
            return res
        })
    }
}

export default new Store()
